import { Geolocation } from '@ionic-native/geolocation';
import { ConnectivityProvider } from './../connectivity/connectivity';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
declare var google;

/*
  Generated class for the GoogleMapsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class GoogleMapsProvider {

  map: any;
  mapElement: any;
  pleaseConnect: any;
  mapInitialised = false;
  latitude: any;
  longitude: any;
  apiKey = 'AIzaSyDcuvQelAX-JwmkCHbrMFGnEaIpg7mw54M';

  constructor(public http: Http, public connectivityService: ConnectivityProvider, public geolocation: Geolocation) {

  }

  init(mapElement: any, pleaseConnect: any, latitude: any, longitude: any): Promise<any> {

    this.mapElement = mapElement;
    this.pleaseConnect = pleaseConnect;
    this.latitude = latitude;
    this.longitude = longitude;
    return this.loadGoogleMaps();
  }

  loadGoogleMaps(): Promise<any> {
    return new Promise((resolve) => {
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.log('Google maps JavaScript needs to be loaded.');
        this.disableMap();
        if (this.connectivityService.isOnline()) {
          window['mapInit'] = () => {
            this.initMap().then((map) => {
              resolve(map);
            });
            this.enableMap();
          }

          const script = document.createElement('script');
          script.id = 'googleMaps';
          if (this.apiKey) {
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
          } else {
            script.src = 'https://maps.googleapis.com/maps/api/js?callback=mapInit';
          }

          document.body.appendChild(script);
        }
      } else {
        console.log('ELSE A');
        console.log('this.connectivityService.isOnline()', this.connectivityService.isOnline());
        if (this.connectivityService.isOnline()) {

          this.initMap().then((map) => {
            console.log('SETELAH INIT SEBELUM RESOLVE');
            resolve(map);
          });
          this.enableMap();
        } else {
          console.log('ELSE B');
          this.disableMap();
        }
      }
      this.addConnectivityListeners();
    })
  }

  initMap(): Promise<any> {
    this.mapInitialised = true;

    return new Promise((resolve) => {
      // this.geolocation.getCurrentPosition().then((position) => {

      const latLng = new google.maps.LatLng(this.latitude, this.longitude);

      const mapOptions = {
        center: latLng,
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'auto',
        disableDefaultUI: true
      }

      this.map = new google.maps.Map(this.mapElement, mapOptions);
      resolve(this.map);
      // })
    })
  }

  resize(): Promise<any> {
    return new Promise((resolve) => {
      if (this.map) {
        google.maps.event.trigger(this.mapElement, 'resize');
      }
      resolve(this.map);
    })
  }

  disableMap(): void {
    if (this.pleaseConnect) {
      this.pleaseConnect.style.display = 'block';
    }
  }

  enableMap(): void {
    if (this.pleaseConnect) {
      this.pleaseConnect.style.display = 'none';
    }
  }

  addConnectivityListeners(): void {

    this.connectivityService.watchOnline().subscribe(() => {

      setTimeout(() => {

        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
          this.loadGoogleMaps();
        } else {
          if (!this.mapInitialised) {
            this.initMap();
          }

          this.enableMap();
        }

      }, 2000);

    });

    this.connectivityService.watchOffline().subscribe(() => {
      this.disableMap();
    });

  }
}



// WEBPACK FOOTER //
// ./src/providers/google-maps/google-maps-provider.ts